import { ScheduleType } from 'modules/domains/campaign';
import { ScheduleEligibilityFormState, ScheduleFormState } from '../../types';
import { ProjectTimeZoneScheduleDateSummary } from '../ConfirmScheduleCampaignModal/ConfirmScheduleCampaignContent/ProjectTimeZoneScheduleDateSummary';
import { RecipientTimeZoneScheduleDateSummary } from '../ConfirmScheduleCampaignModal/ConfirmScheduleCampaignContent/RecipientTimeZoneScheduleDateSummary';
import { ScheduleImmediatelySummary } from './ScheduleImmediatelySummary';

export const SCHEDULE_TYPE_DATE_SUMMARY_MAPPER = {
  [ScheduleType.ProjectTimeZone]: ProjectTimeZoneScheduleDateSummary,
  [ScheduleType.RecipientTimeZone]: RecipientTimeZoneScheduleDateSummary,
};

export const ConfirmDisplayEligibilityCampaignContent = ({
  values,
}: {
  values?: ScheduleEligibilityFormState | ScheduleFormState;
}) => {
  const { scheduleType, startDate, startTime } = values as ScheduleEligibilityFormState;

  const ScheduleDateSummary =
    SCHEDULE_TYPE_DATE_SUMMARY_MAPPER?.[scheduleType] ??
    SCHEDULE_TYPE_DATE_SUMMARY_MAPPER?.[ScheduleType.ProjectTimeZone];

  const ScheduleSummary = startDate && startTime ? ScheduleDateSummary : ScheduleImmediatelySummary;

  return <ScheduleSummary values={values as ScheduleFormState} />;
};
